(() => {
  window.PXUTheme = window.PXUTheme || {};

  window.PXUTheme.jsSidebar = {
    init() {
      this.facetedFilterForm = document.querySelector('[data-faceted-filter-form]');
      this.toggleContainers = Array.from(document.querySelectorAll('[data-has-toggle-option]'));
      this.sidebarSectionEls = Array.from(document.querySelectorAll('.section--has-sidebar-option'));
      this.productSidebarExists = !!document.querySelector('[data-product-sidebar]');

      if (this.facetedFilterForm) {
        this.onFacetedFilterChange = this.handleFacetedFilterChange.bind(this);
        this.facetedFilterForm.addEventListener('change', this.onFacetedFilterChange);
      }

      const openSidebarBlocks = document.querySelectorAll('[data-sidebar-block__toggle="open"]');
      openSidebarBlocks.forEach((block) => {
        window.PXUTheme.jsSidebar.openSidebarBlock(block);
      });

      this.onToggleClick = this.handleToggleClick.bind(this);
      this.toggleContainers.forEach((container) => {
        container.addEventListener('click', this.onToggleClick);
      });

      this.updateSidebarStateClasses();
    },

    handleFacetedFilterChange(e) {
      if (e.target.type === 'number') return;

      /*
        We need to ensure search params unrelated to the faceted filtering (eg. sorting or
        vendors collection) remain in the URL and only the faceted filtering params get updated.
        In order to do this, instead of submitting the `facetedFilterForm` form, we'll
        just get the faceted filter params we need from it and add it to the URL ourselves.
      */
      const formData = new FormData(this.facetedFilterForm);
      const facetedFilterSearchParams = new URLSearchParams(formData);
      const existingSearchParams = new URLSearchParams(window.location.search);
      const newSearchParams = new URLSearchParams();

      Array.from(facetedFilterSearchParams.entries()).forEach(([key, value]) => {
        newSearchParams.append(key, value);
      });

      Array.from(existingSearchParams.entries()).forEach(([key, value]) => {
        /*
          Do not set or update key-value pair if key is related to faceted filtering.
          This is to help prevent unrelated params (eg. sorting) from getting removed.
        */
        if (!key.includes('filter.p') && !key.includes('filter.v')) {
          newSearchParams.append(key, value);
        }
      });

      window.location.search = newSearchParams.toString();
    },

    handleToggleClick(e) {
      const toggleBtn = e.target.closest('[data-sidebar-block__toggle]');
      if (!toggleBtn) return;

      e.preventDefault();

      const state = toggleBtn.getAttribute('data-sidebar-block__toggle');

      if (state === 'closed') {
        window.PXUTheme.jsSidebar.openSidebarBlock(toggleBtn);
      } else if (state === 'open') {
        window.PXUTheme.jsSidebar.closeSidebarBlock(toggleBtn);
      }
    },

    updateSidebarStateClasses() {
      this.sidebarSectionEls.forEach((section) => {
        if (this.productSidebarExists) {
          section.classList.add('has-sidebar-enabled');
          section.classList.remove('has-sidebar-disabled');
        } else {
          section.classList.remove('has-sidebar-enabled');
          section.classList.add('has-sidebar-disabled');
        }
      });
    },

    openSidebarBlock(toggleBtn) {
      const parentBlock = toggleBtn.closest('.sidebar__block');
      if (!parentBlock) return;

      toggleBtn.setAttribute('data-sidebar-block__toggle', 'open');

      parentBlock.classList.add('is-active');
      parentBlock.setAttribute('aria-expanded', 'true');

      const collapsible = parentBlock.querySelector('[data-sidebar-block__content--collapsible]');
      if (collapsible) {
        this.slideDown(collapsible);
      }
    },

    closeSidebarBlock(toggleBtn) {
      const parentBlock = toggleBtn.closest('.sidebar__block');
      if (!parentBlock) return;

      toggleBtn.setAttribute('data-sidebar-block__toggle', 'closed');

      parentBlock.classList.remove('is-active');
      parentBlock.setAttribute('aria-expanded', 'false');

      const collapsible = parentBlock.querySelector('[data-sidebar-block__content--collapsible]');
      if (collapsible) {
        this.slideUp(collapsible);
      }
    },

    slideDown(element, duration = 300) {
      element.style.removeProperty('display');
      let display = window.getComputedStyle(element).display;

      if (display === 'none') {
        display = 'block';
      }

      element.style.display = display;
      const height = element.scrollHeight;

      element.style.overflow = 'hidden';
      element.style.height = '0';
      element.style.paddingTop = '0';
      element.style.paddingBottom = '0';
      element.style.marginTop = '0';
      element.style.marginBottom = '0';

      element.offsetHeight;

      element.style.transitionProperty = 'height, margin, padding';
      element.style.transitionDuration = `${duration}ms`;
      element.style.height = `${height}px`;

      element.style.removeProperty('padding-top');
      element.style.removeProperty('padding-bottom');
      element.style.removeProperty('margin-top');
      element.style.removeProperty('margin-bottom');

      window.setTimeout(() => {
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
      }, duration);
    },

    slideUp(element, duration = 300) {
      element.style.height = `${element.offsetHeight}px`;
      element.style.overflow = 'hidden';

      element.offsetHeight;

      element.style.transitionProperty = 'height, margin, padding';
      element.style.transitionDuration = `${duration}ms`;
      element.style.height = '0';
      element.style.paddingTop = '0';
      element.style.paddingBottom = '0';
      element.style.marginTop = '0';
      element.style.marginBottom = '0';

      window.setTimeout(() => {
        element.style.display = 'none';
        element.style.removeProperty('height');
        element.style.removeProperty('overflow');
        element.style.removeProperty('transition-duration');
        element.style.removeProperty('transition-property');
        element.style.removeProperty('padding-top');
        element.style.removeProperty('padding-bottom');
        element.style.removeProperty('margin-top');
        element.style.removeProperty('margin-bottom');
      }, duration);
    },

    unload() {
      if (this.facetedFilterForm && this.onFacetedFilterChange) {
        this.facetedFilterForm.removeEventListener('change', this.onFacetedFilterChange);
      }

      if (this.toggleContainers && this.onToggleClick) {
        this.toggleContainers.forEach((container) => {
          container.removeEventListener('click', this.onToggleClick);
        });
      }
    },
  };
})();